import { render, staticRenderFns } from "./Almacen.vue?vue&type=template&id=6356f0ae&scoped=true"
import script from "./Almacen.vue?vue&type=script&lang=js"
export * from "./Almacen.vue?vue&type=script&lang=js"
import style0 from "./Almacen.vue?vue&type=style&index=0&id=6356f0ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356f0ae",
  null
  
)

export default component.exports